<div ngbDropdown [container]="container" [autoClose]="true" placement="bottom-right" class="d-inline-block ms-1" (openChange)="onOpenChange($event)">
    <button class="btn btn-info btn-sm" id="columnsDropdown"
            ngbDropdownToggle>
        <i class="fa fa-table-columns"></i><span class="ms-1">{{ 'columns' | translate }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="columnsDropdown" class="p-3 custom-menu-dropdown-style">
        <div class="mb-2">
            <div class="input-group">
                <span class="input-group-text" id="inputGroup-sizing-sm"><i class="fa fa-search"></i></span>
                <input type="text" class="form-control" placeholder="{{'search' | translate}}" [(ngModel)]="searchTerm"
                       (keyup)="onSearchColumn($event)"/>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col">
                @if (showGroupToggle) {
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" [(ngModel)]="isGrouped"
                               (change)="onGroupedChanged()">
                        <label class="form-check-label" for="flexSwitchCheckDefault">{{'study-editor.column-selector.group-view' | translate}}</label>
                    </div>
                }
            </div>
            <div class="col d-flex justify-content-end align-items-center">
                <button class="btn btn-sm btn-outline-info ms-2" (click)="resetColumns()" [disabled]="disabled"><i
                        class="fa fa-undo"></i> {{'reset' | translate}}
                </button>
            </div>
            <hr class="hr mt-2 mb-0" />
        </div>
        <div class="columns-container scrollable-container custom-scroll-style" cdkDropList
             cdkDropListOrientation="vertical" (cdkDropListDropped)="dropColumn($event)">
            @if (isGrouped) {
                <ng-container *ngFor="let columnGroup of columnGroupsMap | keyvalue">
                    <div class="mb-3" *ngIf="columnGroup.value.columns.length > 0">
                        <div class="border-bottom pb-2 d-flex justify-content-between align-items-center">
							<h6 class="group-view-header">{{ columnGroup.value.name | translate | uppercase }}</h6>
							@if (enableHidingByGroup) {
								<a *ngIf="columnGroup.value.hidden" class="pe-2" (click)="toggleDisplayGroupColumns(columnGroup.key, false)">{{ 'show-all' | translate }}</a>
								<a *ngIf="!columnGroup.value.hidden" class="pe-2" (click)="toggleDisplayGroupColumns(columnGroup.key, true)">{{ 'hide-all' | translate }}</a>
							}
						</div>
                        <div class="d-flex align-items-center p-2 column-item"
                        *ngFor="let columnIndex of columnGroup.value.columns"
                         [style.pointer-events]="disabled ? 'none' : 'auto'"
                         [ngClass]="{'disabled-item': disabled}"
                        >
                            @if (displayedColumns[columnIndex].columnSelectorVisible && COLUMN_SELECTOR_CHECKBOX_ID !== displayedColumns[columnIndex].id) {
                                <i class="fa"
                                   [ngClass]="{'fa-eye': displayedColumns[columnIndex].selected, 'fa-eye-slash': !displayedColumns[columnIndex].selected, 'text-muted': !displayedColumns[columnIndex].selected}"
                                   (click)="displayedColumns[columnIndex].selected = !displayedColumns[columnIndex].selected; onChanged(displayedColumns[columnIndex])"
                                   [id]="'eye-' + displayedColumns[columnIndex].termId"
                                   style="cursor: pointer;"></i>
                                <label class="ms-2 mb-0" style="cursor: pointer;"
                                       (click)="displayedColumns[columnIndex].selected = !displayedColumns[columnIndex].selected; onChanged(displayedColumns[columnIndex])"
                                       [ngClass]="{'fw-bold': displayedColumns[columnIndex].selected, 'text-muted': !displayedColumns[columnIndex].selected}">
                                    @if (getStaticColumnLabelKey(displayedColumns[columnIndex]?.termId)) {
                                        {{ getStaticColumnLabelKey(displayedColumns[columnIndex]?.termId) | translate }}
                                    } @else {
                                        {{ displayedColumns[columnIndex].displayName }}
                                    }
                                </label>
                            }
                        </div>
                    </div>
                </ng-container>
            } @else {
                @for (column of displayedColumns; track column.id) {
                    @if (column.columnSelectorVisible && COLUMN_SELECTOR_CHECKBOX_ID !== column.id) {
                        <div class="d-flex align-items-center p-2 column-item" cdkDrag [cdkDragDisabled]="!isSearchTermEmpty() || disabled"
                             [style.pointer-events]="disabled ? 'none' : 'auto'"
                             [ngClass]="{'disabled-item': disabled}">
                            @if (isSearchTermEmpty()) {
                                <div class="drag-handle me-2" cdkDragHandle>
                                    <i class="fa fa-bars"></i>
                                </div>
                            }
                            <i class="fa"
                               [ngClass]="{'fa-eye': column.selected, 'fa-eye-slash': !column.selected, 'text-muted': !column.selected}"
                               (click)="column.selected = !column.selected; onChanged(column)"
                               [id]="'eye-' + column.termId"
                               style="cursor: pointer;"></i>
                            <label class="ms-2 mb-0" style="cursor: pointer;"
                                   (click)="column.selected = !column.selected; onChanged(column)"
                                   [ngClass]="{'fw-bold': column.selected, 'text-muted': !column.selected}">
                                @if (getStaticColumnLabelKey(column.termId)) {
                                    {{ getStaticColumnLabelKey(column.termId) | translate }}
                                } @else {
                                    {{ column.displayName }}
                                }
                            </label>
                        </div>
                    }
                }
            }
        </div>
    </div>
</div>
